__webpack_require__.p = "/cg-panel/";